import React from 'react';
import { useSelector } from 'react-redux';
import { authSelectors } from 'redux/auth';
import IconButton from '@mui/material/IconButton';
import PulseBadge from 'components/PulseBadge';
import NotificationsIcon from 'components/Icons/Notifications';
import PropTypes from 'prop-types';

const NotificationsIconButton = React.forwardRef(({ fontSize, ...rest }, ref) => {

  const notificationsCount = useSelector(authSelectors.getNotificationCount);
  const hasNotifications = notificationsCount > 0;

  return (
    <IconButton ref={ref} color={hasNotifications ? 'primary' : 'inherit'} {...rest}>
      <PulseBadge badgeContent={notificationsCount} color="primary">
        <NotificationsIcon fontSize={fontSize} />
      </PulseBadge>
    </IconButton>
  );
});

NotificationsIconButton.propTypes = {
  fontSize: PropTypes.oneOf(['default', 'inherit', 'large', 'small']),
};

export default NotificationsIconButton;
